import FileIcon from "@/assets/images/icons2/icon--file.svg?component";
import { changeFileExtension } from "@/lib/helpers/changeFileExtension";
import { cn } from "@/lib/helpers/cn";
import { FileTrigger2 } from "@/ui2/molecules/FileTrigger";

import { ALLOWED_EXTENSIONS, ALLOWED_MIME } from "../constants";

type PhotoUploaderProps = {
  file: Nullable<File>;
  fileStateSetter: (file: File[]) => void;
  isLoading: boolean;
  isValid: boolean;
};

export function PhotoUploader({ file, fileStateSetter, isLoading, isValid }: PhotoUploaderProps) {
  const isPrimaryPickerShown = !file || !isValid || isLoading;
  const isSecondaryPickerShown = file && isValid && !isLoading;

  return (
    <>
      {isPrimaryPickerShown && (
        <>
          <p className="tw:flex tw:flex-col tw:text-center body-md">
            <b>Upload front of your identity document</b>
            (driver's license, state ID, or passport)
          </p>

          <div className="tw:flex tw:flex-col tw:items-center tw:gap-6 tw:max-w-60 tw:mx-auto">
            <FileTrigger2
              acceptedFileTypes={ALLOWED_MIME}
              buttonProps={{
                children: "Upload ID",
                className: "tw:min-w-45",
                isLoading,
                labelLoading: "Uploading...",
                size: "lg",
              }}
              fileStateSetter={fileStateSetter}
            />

            <small className="body-sm tw:text-center tw:text-text-secondary">
              {ALLOWED_EXTENSIONS} allowed.
              <br />
              Max file size: 20MB
            </small>
          </div>
        </>
      )}

      {isSecondaryPickerShown && (
        <div className="tw:grid tw:grid-cols-[1fr_auto] tw:gap-5 tw:items-center">
          <p
            className={cn(
              "body-md tw:flex tw:gap-1.5",
              "tw:min-w-0", // important for truncate to work
            )}
          >
            <FileIcon className="tw:-mt-0.5 tw:shrink-0 tw:text-text-secondary" />

            <span className="tw:truncate" title={file?.name}>
              {changeFileExtension(file.name, "jpg")}
            </span>
          </p>

          <FileTrigger2
            acceptedFileTypes={ALLOWED_MIME}
            buttonProps={{
              children: "Re-upload",
              isDisabled: isLoading,
              size: "sm",
              variant: "secondary",
            }}
            fileStateSetter={fileStateSetter}
          />
        </div>
      )}
    </>
  );
}
